import React from 'react';
import { PlusOutlined, WarningOutlined } from '@ant-design/icons';

export default function Inventory() {

  return (
    <div>
      <div className="page-header">
        <div><h2>Inventory</h2><p>Equipment, chemicals and safety supplies</p></div>
        <button className="btn-aqua"><PlusOutlined /> Add Item</button>
      </div>
    </div>
  );
}
